(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["AA-new-collection-tab"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(section) {
      var tabs = section.querySelectorAll('.prange__tab');
      var panels = section.querySelectorAll('.prange__panel');

      // Tabs
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var targetId = tab.dataset.target;

          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.id === targetId);
          });
        });
      });

      // Mobile tab-strip prev/next buttons — scroll the tabs container horizontally
      var tabScroll = section.querySelector('[data-prange-tabs-scroll]');
      var tabPrev   = section.querySelector('[data-prange-tabs-prev]');
      var tabNext   = section.querySelector('[data-prange-tabs-next]');
      if (tabScroll && tabPrev && tabNext) {
        function tabStep() {
          var firstTab = tabScroll.querySelector('.prange__tab');
          if (!firstTab) return tabScroll.clientWidth * 0.7;
          return firstTab.getBoundingClientRect().width + 12; // gap ≈ 12
        }
        function updateTabsNav() {
          var max = tabScroll.scrollWidth - tabScroll.clientWidth - 1;
          tabPrev.disabled = tabScroll.scrollLeft <= 0;
          tabNext.disabled = tabScroll.scrollLeft >= max;
        }
        tabPrev.addEventListener('click', function () {
          tabScroll.scrollBy({ left: -tabStep(), behavior: 'smooth' });
        });
        tabNext.addEventListener('click', function () {
          tabScroll.scrollBy({ left: tabStep(), behavior: 'smooth' });
        });
        tabScroll.addEventListener('scroll', updateTabsNav, { passive: true });
        window.addEventListener('resize', updateTabsNav);
        updateTabsNav();
      }

      // Wire up slider buttons on every panel that has them
      section.querySelectorAll('.prange__panel').forEach(function (panel) {
        var viewport = panel.querySelector('.prange__viewport');
        var prev = panel.querySelector('.prange__nav--prev');
        var next = panel.querySelector('.prange__nav--next');
        if (!viewport || !next) return;

        function step() {
          var card = panel.querySelector('.prange-card');
          if (!card) return viewport.clientWidth * 0.8;
          var rect = card.getBoundingClientRect();
          return rect.width + 32; /* gap = 32 */
        }

        function update() {
          if (!prev || !next) return;
          var max = viewport.scrollWidth - viewport.clientWidth - 1;
          prev.toggleAttribute('hidden', viewport.scrollLeft <= 0);
          next.toggleAttribute('hidden', viewport.scrollLeft >= max);
        }

        if (prev) prev.addEventListener('click', function () {
          viewport.scrollBy({ left: -step(), behavior: 'smooth' });
        });
        if (next) next.addEventListener('click', function () {
          viewport.scrollBy({ left: step(), behavior: 'smooth' });
        });
        viewport.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      });
    }

    function init() {
      document.querySelectorAll('.prange[data-section-id]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["AA-new-hero-banner"] && !Shopify.designMode) return;
  try {
    
  /* Toggle body class only while the TOP HERO area is in view (the dog +
     headline block, above the OsteoConnect card). Paws show in the sticky
     header during this section, then disappear as soon as the card scrolls
     into view — matching the white card backdrop. */
  (function () {
    var heroTop = document.querySelector('.bdsh__top');
    if (heroTop && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          document.body.classList.toggle('bds-hero-visible', entry.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(heroTop);
    } else if (heroTop) {
      // Fallback for browsers without IntersectionObserver — assume visible at top
      document.body.classList.add('bds-hero-visible');
    }
  })();

  /* Smooth-scroll the primary CTA to its target anchor (e.g. #recommendation-quiz). */
  (function () {
    var ctas = document.querySelectorAll('[data-bdsh-cta-primary]');
    if (!ctas.length) return;
    ctas.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Update URL hash without jumping
        if (history.replaceState) history.replaceState(null, '', href);
      });
    });
  })();

  (function () {
    var roots = document.querySelectorAll('[data-bds-hero-cta][data-sale-end]');
    if (!roots.length) return;

    function diffParts(ms) {
      if (ms < 0) ms = 0;
      var totalSeconds = Math.floor(ms / 1000);
      var weeks   = Math.floor(totalSeconds / (7 * 24 * 3600));
      var days    = Math.floor((totalSeconds % (7 * 24 * 3600)) / (24 * 3600));
      var hours   = Math.floor((totalSeconds % (24 * 3600)) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      return { weeks: weeks, days: days, hours: hours, minutes: minutes, seconds: seconds };
    }

    function start(root) {
      var endIso = root.getAttribute('data-sale-end');
      var endMs  = Date.parse(endIso);
      if (isNaN(endMs)) return;

      var timers = root.querySelectorAll('[data-bds-hero-cta-timer]');
      if (!timers.length) return;

      var intervalId;
      function tick() {
        var parts = diffParts(endMs - Date.now());
        timers.forEach(function (timer) {
          ['weeks','days','hours','minutes','seconds'].forEach(function (unit) {
            var node = timer.querySelector('[data-unit="' + unit + '"]');
            if (node) node.textContent = parts[unit];
          });
        });
        if (endMs - Date.now() <= 0 && intervalId) {
          clearInterval(intervalId);
        }
      }

      tick();
      intervalId = setInterval(tick, 1000);
    }

    roots.forEach(start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["AA-new-target-solution"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(section) {
      var sectionId = section.dataset.sectionId;

      function getById(name) {
        return section.querySelector('#' + name + '-' + sectionId);
      }
      function setText(el, text) { if (el) el.textContent = text; }
      function setSrc(el, src)   { if (el && src) el.setAttribute('src', src); }
      function setHref(el, href) { if (el && href) el.setAttribute('href', href); }

      var hotspots = section.querySelectorAll('.hotspot');
      if (!hotspots.length) return;

      function update(btn) {
        var d = btn.dataset;
        setText(getById('bodyMapTitle'),         d.title || '');
        setText(getById('bodyMapDesc'),          d.description || '');
        setSrc (getById('bodyMapIcon'),          d.icon);
        setSrc (getById('bodyMapProductImage'),  d.productImage);
        setText(getById('bodyMapProductTitle'),  d.productTitle || '');
        setText(getById('bodyMapProductDesc'),   d.productDesc || '');

        var oldEl = getById('bodyMapPriceOld');
        if (oldEl) {
          oldEl.textContent = d.priceOld || '';
          oldEl.style.display = d.priceOld ? '' : 'none';
        }
        setText(getById('bodyMapPriceNow'), d.priceNow || '');
        setHref(getById('bodyMapView'),     d.url);
      }

      // Track the currently clicked (permanent) hotspot so hover preview can revert
      var activeBtn = section.querySelector('.hotspot.is-active') || hotspots[0];

      hotspots.forEach(function (btn) {
        // Click = permanent selection
        btn.addEventListener('click', function () {
          hotspots.forEach(function (b) { b.classList.remove('is-active', 'is-hover'); });
          btn.classList.add('is-active');
          activeBtn = btn;
          update(btn);
        });

        // Hover = temporary preview (panel + green marker), reverts on mouseleave
        btn.addEventListener('mouseenter', function () {
          if (btn === activeBtn) return;
          btn.classList.add('is-hover');
          update(btn);
        });
        btn.addEventListener('mouseleave', function () {
          if (btn === activeBtn) return;
          btn.classList.remove('is-hover');
          if (activeBtn) update(activeBtn);
        });

        // Same for keyboard focus/blur (accessibility parity)
        btn.addEventListener('focus', function () {
          if (btn === activeBtn) return;
          btn.classList.add('is-hover');
          update(btn);
        });
        btn.addEventListener('blur', function () {
          if (btn === activeBtn) return;
          btn.classList.remove('is-hover');
          if (activeBtn) update(activeBtn);
        });
      });
    }

    function init() {
      document.querySelectorAll('.body-map[data-section-id]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["AA-recommendation-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var data, products, config;
      try {
        data     = JSON.parse(section.querySelector('[data-quiz-data]').textContent);
        products = JSON.parse(section.querySelector('[data-quiz-products]').textContent);
        config   = JSON.parse(section.querySelector('[data-quiz-config]').textContent);
      } catch (e) { return; }

      var stepsHost   = section.querySelector('[data-quiz-steps]');
      var continueBtn = section.querySelector('[data-quiz-continue]');
      var backBtn     = section.querySelector('[data-quiz-back]');
      var dots        = section.querySelectorAll('[data-step-dot]');

      var panels = {
        questions: section.querySelector('[data-quiz-panel="questions"]'),
        form:      section.querySelector('[data-quiz-panel="form"]'),
        result:    section.querySelector('[data-quiz-panel="result"]')
      };
      var formEl    = section.querySelector('[data-quiz-form]');
      var skipBtn   = section.querySelector('[data-quiz-skip]');
      var retakeBtn = section.querySelector('[data-quiz-retake]');

      var state = {
        index: 0,                               // current step index (0..n-1)
        answers: new Array(data.questions.length).fill(null), // selected option index per step
        scores: { OSTEO: 0, LUM: 0, ROO: 0, EPLUS: 0, ENRICH: 0 }
      };

      // Build step DOM
      data.questions.forEach(function (q, qIdx) {
        var step = document.createElement('div');
        step.className = 'rqz__step' + (qIdx === 0 ? ' is-active' : '');
        step.setAttribute('data-step', String(qIdx + 1));
        step.setAttribute('role', 'group');
        step.setAttribute('aria-labelledby', 'rqz-q-' + qIdx);

        var h = document.createElement('p');
        h.className = 'rqz__question';
        h.id = 'rqz-q-' + qIdx;
        h.textContent = q.title;
        step.appendChild(h);

        var ul = document.createElement('ul');
        ul.className = 'rqz__options';
        ul.setAttribute('role', 'radiogroup');

        q.options.forEach(function (opt, oIdx) {
          var li = document.createElement('li');
          var label = document.createElement('label');
          label.className = 'rqz__option';
          label.setAttribute('data-option-index', String(oIdx));

          var input = document.createElement('input');
          input.type = 'radio';
          input.name = 'rqz_q_' + qIdx;
          input.value = String(oIdx);
          input.className = 'rqz__option-input';

          var text = document.createElement('span');
          text.className = 'rqz__option-text';
          text.textContent = opt.label;

          var radio = document.createElement('span');
          radio.className = 'rqz__option-radio';
          radio.setAttribute('aria-hidden', 'true');

          label.appendChild(input);
          label.appendChild(text);
          label.appendChild(radio);
          li.appendChild(label);
          ul.appendChild(li);

          input.addEventListener('change', function () {
            // Mark selection visually inside this step
            ul.querySelectorAll('.rqz__option').forEach(function (el) { el.classList.remove('is-selected'); });
            label.classList.add('is-selected');

            state.answers[qIdx] = oIdx;
            updateContinueState();
          });
        });

        step.appendChild(ul);
        stepsHost.appendChild(step);
      });

      function updateDots() {
        dots.forEach(function (d, i) {
          d.classList.remove('is-active', 'is-done');
          if (i < state.index) d.classList.add('is-done');
          else if (i === state.index) d.classList.add('is-active');
        });
      }

      function showStep(i) {
        var allSteps = stepsHost.querySelectorAll('.rqz__step');
        allSteps.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
        updateDots();
        updateBackState();
        updateContinueState();
      }

      function updateBackState() {
        if (!backBtn) return;
        if (state.index > 0) backBtn.removeAttribute('hidden');
        else backBtn.setAttribute('hidden', '');
      }

      function updateContinueState() {
        var hasAnswer = state.answers[state.index] !== null;
        continueBtn.disabled = !hasAnswer;

        var defaultLabel = continueBtn.getAttribute('data-label-default') || 'Continue';
        var finalLabel   = continueBtn.getAttribute('data-label-final')   || 'See your recommendation';
        continueBtn.textContent = (state.index === data.questions.length - 1) ? finalLabel : defaultLabel;
      }

      function recalcScores() {
        // Rebuild scores from scratch in case the user navigates back and changes an answer
        state.scores = { OSTEO: 0, LUM: 0, ROO: 0, EPLUS: 0, ENRICH: 0 };
        state.answers.forEach(function (oIdx, qIdx) {
          if (oIdx === null) return;
          var s = data.questions[qIdx].options[oIdx].score || {};
          Object.keys(s).forEach(function (k) {
            if (state.scores[k] === undefined) state.scores[k] = 0;
            state.scores[k] += s[k];
          });
        });
      }

      continueBtn.addEventListener('click', function () {
        if (state.answers[state.index] === null) return;

        if (state.index < data.questions.length - 1) {
          state.index += 1;
          showStep(state.index);
        } else {
          // End of Q4 — go to Step 5 (email form)
          recalcScores();
          showPanel('form');
        }
      });

      // ---- Panel switcher ----
      function showPanel(name) {
        Object.keys(panels).forEach(function (k) {
          if (!panels[k]) return;
          var on = (k === name);
          panels[k].hidden = !on;
          panels[k].classList.toggle('is-active', on);
        });
        if (backBtn) backBtn.setAttribute('hidden', '');
      }

      // ---- Recommendation logic (per spec) ----
      function chooseRecommendation() {
        var scores = state.scores;
        var max = -Infinity;
        Object.keys(scores).forEach(function (k) { if (scores[k] > max) max = scores[k]; });

        // Below-threshold engagement → fallback
        if (max < (config.minScoreThreshold || 5)) return config.fallbackCode || 'OSTEO';

        // Tied set
        var tied = Object.keys(scores).filter(function (k) { return scores[k] === max; });
        if (tied.length === 1) return tied[0];

        // EPLUS vs ENRICH special case
        var q1Idx = state.answers[0];
        var q4Idx = state.answers[3];
        var q1Label = (q1Idx !== null && data.questions[0]) ? data.questions[0].options[q1Idx].label : '';
        var q4Label = (q4Idx !== null && data.questions[3]) ? data.questions[3].options[q4Idx].label : '';
        var prefersEnrich = /appetite loss|recovery from illness/i.test(q1Label) || /recovering from surgery/i.test(q4Label);

        if (tied.indexOf('EPLUS') !== -1 && tied.indexOf('ENRICH') !== -1 && tied.length === 2) {
          return prefersEnrich ? 'ENRICH' : 'EPLUS';
        }

        // General tie-break: pick by configured price order (low → high)
        var order = config.tieBreakOrder || ['ROO', 'EPLUS', 'ENRICH', 'LUM', 'OSTEO'];
        for (var i = 0; i < order.length; i++) {
          if (tied.indexOf(order[i]) !== -1) return order[i];
        }
        return tied[0];
      }

      function formatMoney(cents) {
        if (cents === null || cents === undefined || cents === 0) return '';
        var amount = (cents / 100).toFixed(2);
        return 'A$' + amount;
      }

      // Fallback href for the result button (used when JS click handler can't run)
      // Uses the documented Shopify cart permalink: /cart/{variant_id}:{qty}?discount={code}
      // Note: empty discount value tries to clear any prior discount cached in the cart cookie.
      function buildCheckoutUrl(variantId, code) {
        if (!variantId) return '#';
        return '/cart/' + variantId + ':1?discount=' + encodeURIComponent(code || '');
      }

      // Single Shopify cart permalink: /cart/{variant_id}:1?discount={code}
      // Adds the product, applies the discount (or clears it if empty), goes to /cart → user proceeds to checkout
      function goToCheckout(variantId, code) {
        if (!variantId) return;
        var url = '/cart/' + variantId + ':1';
        if (code) url += '?discount=' + encodeURIComponent(code);
        window.location.href = url;
      }

      // Fetch full product details from Shopify's product.js endpoint
      function fetchProduct(handle) {
        if (!handle) return Promise.resolve(null);
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        return fetch(root + 'products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      }

      // Populate the result panel from a product.js response (productData) + meta (handle/reason).
      // opts.alreadyClaimed = true → email previously claimed the discount; show a
      // different headline that explains the user should check their email.
      function populateResult(code, meta, productData, petName, opts) {
        opts = opts || {};
        var headerEl  = section.querySelector('[data-quiz-result-header]');
        var imageEl   = section.querySelector('[data-quiz-result-image]');
        var nameEl    = section.querySelector('[data-quiz-result-name]');
        var reasonEl  = section.querySelector('[data-quiz-result-reason]');
        var priceEl   = section.querySelector('[data-quiz-result-price]');
        var ctaEl     = section.querySelector('[data-quiz-result-cta]');

        // Header copy
        if (opts.alreadyClaimed) {
          // Email has already redeemed the discount once — single-sentence header only.
          headerEl.textContent =
            'This email has already signed up for the discount. Based on your answer, here is your recommendation.';
        } else if (petName && config.resultHeaderName) {
          headerEl.textContent = config.resultHeaderName.split('[NAME]').join(petName);
        } else {
          headerEl.textContent = config.resultHeaderNoName || 'Based on your answers, we recommend:';
        }

        var title     = (productData && productData.title) || code;
        var image     = (productData && productData.featured_image) || '';
        var basePrice = (productData && productData.price) || 0;
        var variantId = '';
        if (productData && Array.isArray(productData.variants) && productData.variants.length) {
          // Prefer the first available variant; fallback to first variant
          var firstAvail = productData.variants.find ? productData.variants.find(function (v) { return v.available; }) : null;
          variantId = (firstAvail && firstAvail.id) || productData.variants[0].id;
        }

        // Image
        imageEl.innerHTML = '';
        if (image) {
          var img = document.createElement('img');
          img.src = image;
          img.alt = title;
          img.loading = 'lazy';
          imageEl.appendChild(img);
        }

        nameEl.textContent = title;
        reasonEl.textContent = meta.reason || '';

        // Price block
        priceEl.innerHTML = '';
        var hasDiscount = !!(state.discountSubmitted && config.discountCode);
        var discountPct = (typeof config.discountPercent === 'number') ? config.discountPercent : 15;
        var discountedPrice = hasDiscount ? Math.round(basePrice * (1 - discountPct / 100)) : basePrice;

        if (basePrice > 0) {
          var nowEl = document.createElement('span');
          nowEl.className = 'rqz__price-now';
          if (hasDiscount) {
            nowEl.textContent = formatMoney(discountedPrice);
            priceEl.appendChild(nowEl);

            var wasEl = document.createElement('span');
            wasEl.className = 'rqz__price-was';
            wasEl.textContent = formatMoney(basePrice);
            priceEl.appendChild(wasEl);

            var chip = document.createElement('span');
            chip.className = 'rqz__price-chip';
            // Auto-generated from the percentage — single source of truth
            chip.textContent = discountPct + '% off applied';
            priceEl.appendChild(chip);
          } else {
            nowEl.textContent = formatMoney(basePrice);
            priceEl.appendChild(nowEl);
          }
        }

        // CTA — adds to cart and goes to /checkout (discount applied if email submitted)
        var ctaCode = hasDiscount ? config.discountCode : '';
        ctaEl.href = buildCheckoutUrl(variantId, ctaCode); // fallback if JS click intercept fails
        ctaEl.textContent = (config.ctaLabel || 'Continue to Checkout') + (basePrice > 0
          ? ' — ' + formatMoney(discountedPrice)
          : '');

        // Replace any prior click handler with a fresh one bound to current variant + code
        if (ctaEl._rqzClick) ctaEl.removeEventListener('click', ctaEl._rqzClick);
        ctaEl.classList.remove('is-loading');
        ctaEl.removeAttribute('aria-disabled');

        ctaEl._rqzClick = function (e) {
          // One-shot: ignore any subsequent clicks while loading or after first click
          if (ctaEl.classList.contains('is-loading') || ctaEl.getAttribute('aria-disabled') === 'true') {
            e.preventDefault();
            return;
          }
          if (!variantId) return; // let the href fallback handle it
          e.preventDefault();
          ctaEl.classList.add('is-loading');
          ctaEl.setAttribute('aria-disabled', 'true');
          ctaEl.dataset.originalLabel = ctaEl.textContent;
          ctaEl.innerHTML = '<span class="rqz__spinner" aria-hidden="true"></span><span class="rqz__cta-loading-text">Loading…</span>';
          goToCheckout(variantId, ctaCode);
        };
        ctaEl.addEventListener('click', ctaEl._rqzClick);

        section.dispatchEvent(new CustomEvent('rqz:complete', {
          detail: {
            recommendation: code,
            recommendedProductTitle: title,
            recommendedProductHandle: meta.handle || '',
            scores: state.scores,
            answers: state.answers,
            email: state.email || null,
            petName: petName || null,
            weightBand: state.weightBand || null,
            discountApplied: hasDiscount
          }
        }));
      }

      function renderResult(petName) {
        var code = chooseRecommendation();
        var meta = products[code] || {};
        showPanel('result');
        // Show fallback name immediately, then upgrade to live data
        var nameEl = section.querySelector('[data-quiz-result-name]');
        if (nameEl && !nameEl.textContent) nameEl.textContent = code;

        fetchProduct(meta.handle).then(function (productData) {
          populateResult(code, meta, productData, petName);
        });
      }

      // POST lead to the configured webhook. Returns a promise resolving to the parsed
      // JSON response (or null on failure), so the caller can branch on the API status.
      function postLead(payload) {
        if (!config.webhookUrl) return Promise.resolve(null);
        try {
          return fetch(config.webhookUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          })
            .then(function (r) { return r.ok ? r.json().catch(function () { return null; }) : null; })
            .catch(function () { return null; });
        } catch (e) {
          return Promise.resolve(null);
        }
      }
      // Normalize the API status string (accepts both "status" and the documented typo "staus")
      function readLeadStatus(res) {
        if (!res || typeof res !== 'object') return '';
        var s = res.status || res.staus || '';
        return String(s).toLowerCase().trim();
      }

      // ---- Form submit (send my discount code) ----
      if (formEl) {
        formEl.addEventListener('submit', function (e) {
          e.preventDefault();
          var fd = new FormData(formEl);
          var email   = (fd.get('email') || '').toString().trim();
          var petName = (fd.get('pet_name') || '').toString().trim();
          var weight  = (fd.get('weight_band') || '').toString();
          if (!email || !petName) return;

          state.email = email;
          state.petName = petName;
          state.weightBand = weight;
          state.discountSubmitted = true;

          var code = chooseRecommendation();
          var meta = products[code] || {};

          // Fetch product details, then post webhook with product name + render result
          fetchProduct(meta.handle).then(function (productData) {
            var productName = (productData && productData.title) || code;

            postLead({
              email: email,
              pet_name: petName,
              weight_band: weight,
              recommended_product: productName,
              recommended_product_handle: meta.handle || '',
              recommendation_code: code,
              scores: state.scores,
              discount_code: config.discountCode || '',
              submitted_at: new Date().toISOString(),
              source: 'recommendation-quiz'
            }).then(function (leadResponse) {
              var status = readLeadStatus(leadResponse);
              // The API returns "code already sent once" when the email has already
              // been used to claim the discount. In that case we show a different
              // result-panel header (no fresh-discount price treatment).
              var alreadyClaimed = status === 'code already sent once';

              section.dispatchEvent(new CustomEvent('rqz:lead', {
                detail: {
                  email: email,
                  petName: petName,
                  weightBand: weight,
                  scores: state.scores,
                  recommendation: code,
                  recommendedProductTitle: productName,
                  apiStatus: status,
                  alreadyClaimed: alreadyClaimed
                }
              }));

              // If the email was already used, suppress the "discount applied" price
              // treatment so we don't promise a discount the user can't re-redeem.
              state.discountSubmitted = !alreadyClaimed;

              showPanel('result');
              populateResult(code, meta, productData, petName, { alreadyClaimed: alreadyClaimed });
            });
          });
        });
      }

      // ---- Skip discount → go straight to result without lead capture ----
      if (skipBtn) {
        skipBtn.addEventListener('click', function () {
          state.discountSubmitted = false;
          renderResult(null);
        });
      }

      // ---- Retake → reset state and go back to Q1 ----
      if (retakeBtn) {
        retakeBtn.addEventListener('click', function () {
          state.index = 0;
          state.answers = new Array(data.questions.length).fill(null);
          state.scores = { OSTEO: 0, LUM: 0, ROO: 0, EPLUS: 0, ENRICH: 0 };
          state.email = null;
          state.petName = null;
          state.weightBand = null;
          state.discountSubmitted = false;

          // Clear all radio selections
          stepsHost.querySelectorAll('.rqz__option').forEach(function (el) { el.classList.remove('is-selected'); });
          stepsHost.querySelectorAll('input[type="radio"]').forEach(function (el) { el.checked = false; });
          if (formEl) formEl.reset();

          showPanel('questions');
          showStep(0);
        });
      }

      // Back button — go to previous step, restore the previously selected radio
      if (backBtn) {
        backBtn.addEventListener('click', function () {
          if (state.index === 0) return;
          state.index -= 1;
          showStep(state.index);

          // Re-mark the previously chosen radio so user sees their selection
          var prevAnswer = state.answers[state.index];
          if (prevAnswer !== null) {
            var step = stepsHost.querySelectorAll('.rqz__step')[state.index];
            if (step) {
              var input = step.querySelector('input[value="' + prevAnswer + '"]');
              if (input) input.checked = true;
              var labels = step.querySelectorAll('.rqz__option');
              labels.forEach(function (el) { el.classList.remove('is-selected'); });
              var chosen = step.querySelector('.rqz__option[data-option-index="' + prevAnswer + '"]');
              if (chosen) chosen.classList.add('is-selected');
            }
          }
        });
      }

      updateDots();
      updateBackState();
      updateContinueState();
    }

    function boot() {
      document.querySelectorAll('.rqz[data-section-id]').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
